import {
    StyledControlContainer,
    StyledDropdown,
    StyledDropdownListItem,
    StyledPlaceholder,
    StyledRoot
} from 'baseui/select'
import { withStyle } from 'parkdepot-shared/theme'

export const SelectRoot = withStyle(StyledRoot, ({ $theme, $error, $isFocused, $disabled }) => {
    const errorBorderStyle = {
        borderLeftColor: $theme.colors.red700,
        borderRightColor: $theme.colors.red700,
        borderTopColor: $theme.colors.red700,
        borderBottomColor: $theme.colors.red700
    }
    const highlightBorderStyle = {
        borderLeftColor: $theme.colors.primary,
        borderRightColor: $theme.colors.primary,
        borderTopColor: $theme.colors.primary,
        borderBottomColor: $theme.colors.primary
    }
    return {
        border: `1px solid ${$theme.colors.accent200}`,
        borderTopLeftRadius: $theme.sizing.scale800,
        borderTopRightRadius: $theme.sizing.scale800,
        borderBottomRightRadius: $theme.sizing.scale800,
        borderBottomLeftRadius: $theme.sizing.scale800,

        ...($isFocused && highlightBorderStyle),

        ...(!$disabled && {
            ':hover': {
                ...highlightBorderStyle,
                cursor: 'pointer',
                ...($error && errorBorderStyle)
            },
            ':focus': {
                ...highlightBorderStyle,
                ...($error && errorBorderStyle)
            }
        }),

        ...($error && errorBorderStyle)
    }
})

export const SelectControlContainer = withStyle(StyledControlContainer, ({ $theme, $disabled }) => ({
    backgroundColor: $theme.colors.white,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '100px !important',
    fontWeight: 300,
    textOverflow: 'ellipsis',

    ...($disabled && {
        backgroundColor: $theme.colors.mono100
    })
}))

export const SelectDropdownListItem = withStyle(StyledDropdownListItem, ({ $theme }) => ({
    paddingTop: $theme.sizing.scale500,
    paddingBottom: $theme.sizing.scale500,
    lineHeight: $theme.sizing.scale800,

    ':hover': {
        backgroundColor: $theme.colors.mono100
    }
}))

export const SelectPlaceholder = withStyle(StyledPlaceholder, ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    color: $theme.colors.mono300
}))

export const SelectDropdown = withStyle(StyledDropdown, ({ $theme }) => ({
    borderRadius: $theme.sizing.scale800
}))
